import type React from 'react';
import { useState } from 'react';

import * as styles from './styles';

import { CookieManager } from '@cobliteam/cookie-manager';

import { BodyText, Checkbox, ConfirmationModal, type ConfirmationModalProps, DescriptionTitle, ModalType } from '@cobliteam/base-components';

export interface PublishChecklistDialogProps extends Pick<ConfirmationModalProps, 'open' | 'loading' | 'onCancel' | 'onConfirm'> {}

export const REMINDER_COOKIE_NAME = 'not_show_publish_modal_reminder';

export const PublishChecklistDialog: React.FC<PublishChecklistDialogProps> = ({ open, loading, onCancel, onConfirm }) => {
  const [checked, setChecked] = useState(false);
  const handleOnConfirm = () => {
    if (checked) {
      CookieManager.setCookie(REMINDER_COOKIE_NAME, 'true');
    }
    onConfirm();
  };
  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>, isChecked: boolean) => {
    setChecked(isChecked);
  };

  return (
    <ConfirmationModal open={open} loading={loading} onCancel={onCancel} onConfirm={handleOnConfirm} headerText='Publicar alterações' buttonText='Publicar' type={ModalType.SUBMIT}>
      <div className={styles.dialog}>
        <BodyText>
          As alterações serão aplicadas somente para checklists recebidas
          <DescriptionTitle>a partir desta publicação</DescriptionTitle>. Checklists recebidas anteriormente que usam este modelo não sofrerão alterações.
        </BodyText>
        <Checkbox label='Não mostrar novamente' onChange={handleOnChange} />
      </div>
    </ConfirmationModal>
  );
};

export default PublishChecklistDialog;
